import React from 'react';
import './Rules.css';

interface RulesProps {
  compact?: boolean;
}

const Rules: React.FC<RulesProps> = ({ compact = false }) => {
  if (compact) {
    return (
      <div className="rules-compact">
        <h3>🏆 Hunt Rules</h3>
        <p><strong>Time:</strong> 10AM-12PM in Seminar Room 106, KSQ2</p>
        <p><strong>Objective:</strong> Find scavenger items as a team, all members must be in each photo</p>
        <p><strong>Prize:</strong> Team lunch (soft spend limit $25/person) to location of your choice</p>
      </div>
    );
  }

  return (
    <div className="rules-container">
      <div className="rules-header">
        <h2>🏆 BMD Scavenger Hunt Rules</h2>
      </div>
      
      <div className="rules-content">
        <div className="rules-section">
          <h3>📝 Getting Started</h3>
          <ul>
            <li><strong>Choose a Team Name</strong> if you have not done so already - Put Name in the website with a picture of your team.</li>
            <li><strong>Designate a Team Leader</strong> - he will be the one to take and upload pictures.</li>
          </ul>
        </div>

        <div className="rules-section">
          <h3>⏰ Schedule</h3>
          <ul>
            <li><strong>Start time:</strong> 10AM in Seminar room 106 in KSQ2. You will have 2 hours to collect as many items on the list as you can.</li>
            <li><strong>End Time:</strong> 12 PM. <em>The site will lock down at this time. No further submissions will be accepted.</em></li>
            <li><strong>Lunch:</strong> Lunch is being ordered from Saloniki and will begin promptly at 12PM in Seminar room 106 in KSQ2.</li>
          </ul>
        </div>

        <div className="rules-section">
          <h3>🎯 Objective</h3>
          <p>Travel as a group to locate as many scavenger items on the list as you can within the time limit.</p>
          <p><strong>To receive credit for an item, you must have as many members of your team as possible in each photo.</strong></p>
        </div>

        <div className="rules-section">
          <h3>📋 House Rules</h3>
          <p>The Fun committee will be the sole truth for "correct" answers. We will not accept appeals on rejected submissions.</p>
        </div>

        <div className="rules-section prizes-section">
          <h3>🏆 Prizes</h3>
          <ul>
            <li>The team with the most scavenger points will win a team lunch to the location of their choosing.</li>
            <li>$25/person "soft spend limit"</li>
            <li>The senior team member must expense lunch on their corporate card.</li>
            <li>Please send total spent to Morgan (no need to send the receipt, just the total amount) for our budget keeping.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Rules;